import _sfc_main from "./StreamContainerH5.vue2.mjs";
/* empty css                        */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "streamContainerRef", staticClass: "stream-container" }, [_c(_setup.TuiSwiper, { staticClass: "page-stream-container", attrs: { "active-index": _setup.swiperActiveIndex }, on: { "change": _setup.handleSwiperChange } }, [_setup.showLargeAndFloatPage ? _c(_setup.TuiSwiperItem, [_c(_setup.SingleStreamView, { staticClass: "enlarged-stream", attrs: { "streamInfo": _setup.enlargeStream, "support-touch-scale": _setup.isEnlargeScreenStream } }), _setup.floatStream ? _c(_setup.SingleStreamView, { class: ["float-stream", { "show-room-tool": _setup.showRoomTool }], style: _setup.floatStreamStyle, attrs: { "streamInfo": _setup.floatStream } }) : _vm._e()], 1) : _vm._e(), _setup.showEqualPointsPage ? _vm._l(_setup.equalPointsLayoutStreamList, function(item, index) {
    return _c(_setup.TuiSwiperItem, { key: index }, [_c(_setup.MultiStreamView, { staticClass: "page-stream-container", attrs: { "maxColumn": _setup.maxColumn, "maxRow": _setup.maxRow, "stream-info-list": item, "stream-play-mode": _setup.getStreamPlayMode(index) }, on: { "stream-view-dblclick": _setup.handleStreamViewDblclick } })], 1);
  }) : _vm._e()], 2)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const StreamContainerH5 = __component__.exports;
export {
  StreamContainerH5 as default
};
